const { on } = window.ivent;

on(
	document,
	'mouseenter',
	'.card-recommendation, .section-button, .form-subscribe .button, .split-button > .button, .page-404 .button',
	(e) => {
		const item = e.delegateTarget;

		item.classList.remove('hover');
		item.offsetHeight;
		item.classList.add('hover');
	},
);
